import {
    MessageSquare,
} from 'lucide-react';
import { ICredencialDto, IPermisoesDto } from '../../Dtos/CredencialDto';

export interface IMenuItem {
    id: string;
    icon?: React.ReactNode;
    label: string;
    path?: string;
    subItems?: IMenuItem[];
    visible: boolean
}

const credencialDto: ICredencialDto | null = localStorage.getItem("credencial") != null ? JSON.parse(localStorage.getItem("credencial")!) : null

export const credencialTemAcesso = (tarefa: string, permissao: keyof IPermisoesDto) =>{    
    const sd031 = credencialDto?.sd031s?.filter(sd031 => sd031.sd031tarefa.sd02nome.toLowerCase() === tarefa.toLowerCase())
    
    if(sd031 == null || sd031.length < 1) return false
    
    return sd031[0][permissao] === 1;
}


export const menuItems: IMenuItem[] = [
    { 
        id: 'comercial', 
        label: 'Comercial', 
        icon: <MessageSquare size={18} />, 
        subItems: [
            { 
                id: 'licenca', 
                label: 'Licença', 
                path: '/licencas', 
                visible: credencialTemAcesso("licenças", "sd031acessa"),
            },
            { 
                id: 'solicitacoes', 
                label: 'Solicitaçoes', 
                path: '/solicitacoes', 
                visible: credencialTemAcesso("licenças", "sd031inclui"),
            },
            { 
                id: 'solicitar', 
                label: 'Solicitar', 
                path: '/solicitar', 
                visible: credencialTemAcesso("licenças", "sd031acessa"),
            },
            { 
                id: 'prospeccoes', 
                label: 'Prospecções', 
                path: '/prospeccoes', 
                visible: credencialTemAcesso("Prospecção", "sd031acessa"),
            },
            {
                id: 'contratos', 
                label: 'Contratos', 
                path: '/contratos', 
                visible: credencialTemAcesso("Prospecção", "sd031acessa"), 
            },
            {
                id: 'simulador', 
                label: 'Simulador de Preço', 
                path: '/simulador', 
                visible: credencialTemAcesso("Simulador de Preços", "sd031acessa"), 
            },
        ], 
        visible: true,
    },
];